// extracted by mini-css-extract-plugin
module.exports = {"menu":"UserMenu_menu__3GsVp","actions":"UserMenu_actions__142PM","text":"UserMenu_text__SE8CN","user":"UserMenu_user__1WKN6","loggedUser":"UserMenu_loggedUser__2kskA"};